// stores/route.ts
import { defineStore } from 'pinia'

export const useCommonStore = defineStore('common', {
  state: () => ({
    isLighthouseBot: false
  }),
  actions: {
    setIsLighthouseBot(value: boolean) {
      this.isLighthouseBot = value
    }
  }
})
